<ey-froala-content-wrapper [editorContent]="body"></ey-froala-content-wrapper>
<ul class="ps-0 mt-10">
  <li [ngClass]="{ selected: selectedYes }"><i class="icon-ico_check emp-icon"></i>Yes</li>
  <li [ngClass]="{ selected: selectedNo }"><i class="icon-ico_check emp-icon"></i>No</li>
</ul>
